"use client";

import type { Variants } from "motion/react";
import { motion } from "motion/react";
import type { HTMLAttributes } from "react";

import { cn } from "./utils";

const SIZE_MAP = {
  sm: 20,
  md: 28,
  lg: 32,
  xl: 36, // same as SearchLoader (h-9 w-9)
  "2xl": 48,
} as const;

const DEFAULT_SIZE = 36;

interface LoaderProps extends HTMLAttributes<HTMLDivElement> {
  size?: number | keyof typeof SIZE_MAP;
}

const SPARKLE_VARIANTS: Variants = {
  animate: {
    y: [0, -1, 0, 0],
    fill: ["none", "currentColor", "none"],
    transition: {
      duration: 1,
      repeat: Infinity,
      repeatType: "loop",
      ease: "easeInOut",
    },
  },
};

const STAR_VARIANTS: Variants = {
  animate: {
    opacity: [0, 1, 0, 0, 0, 0, 1, 0],
    transition: {
      duration: 2,
      repeat: Infinity,
      repeatType: "loop",
      ease: "easeInOut",
    },
  },
};

export function Loader({ className, size, ...props }: LoaderProps) {
  const pixels =
    size === undefined
      ? DEFAULT_SIZE
      : typeof size === "number"
        ? size
        : SIZE_MAP[size];
  return (
    <div
      className={cn("inline-flex items-center justify-center text-current", className)}
      style={{ width: pixels, height: pixels }}
      {...props}
    >
      <svg
        className="h-full w-full"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <motion.path
          animate="animate"
          d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"
          variants={SPARKLE_VARIANTS}
        />
        <motion.path animate="animate" d="M20 3v4" variants={STAR_VARIANTS} />
        <motion.path animate="animate" d="M22 5h-4" variants={STAR_VARIANTS} />
        <motion.path animate="animate" d="M4 17v2" variants={STAR_VARIANTS} />
        <motion.path animate="animate" d="M5 18H3" variants={STAR_VARIANTS} />
      </svg>
    </div>
  );
}
